// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import { Dictionary } from '../../../shared/models/dictionary.model';
import { IBaseType } from '../../../shared/enums/ibase-type.enum';

export interface IContactMethodType {
    id: number;
    value: string;
    displayValue: string;
    description: string;
    sortOrder: number;
    active: boolean;
}

export class ContactMethodType implements IContactMethodType, IBaseType {
    public id: number;
    public value: string;
    public displayValue: string;
    public description: string;
    public sortOrder: number;
    public active: boolean;

    /**
		Returns Personal Cell ContactMethodType
	**/
    get PersonalCell(): IContactMethodType {
        return this.FromId(1);
    }
    /**
		Returns Business Cell ContactMethodType
	**/
    get BusinessCell(): IContactMethodType {
        return this.FromId(2);
    }
    /**
		Returns Home Landline ContactMethodType
	**/
    get HomeLandline(): IContactMethodType {
        return this.FromId(3);
    }
    /**
		Returns Business Landline ContactMethodType
	**/
    get BusinessLandline(): IContactMethodType {
        return this.FromId(4);
    }
    /**
		Returns Personal Email ContactMethodType
	**/
    get PersonalEmail(): IContactMethodType {
        return this.FromId(5);
    }
    /**
		Returns Business Email ContactMethodType
	**/
    get BusinessEmail(): IContactMethodType {
        return this.FromId(6);
    }
    /**
		Returns Alternative Email ContactMethodType
	**/
    get AlternativeEmail(): IContactMethodType {
        return this.FromId(7);
    }
    /**
		Returns Personal Fax ContactMethodType
	**/
    get PersonalFax(): IContactMethodType {
        return this.FromId(8);
    }
    /**
		Returns Business Fax ContactMethodType
	**/
    get BusinessFax(): IContactMethodType {
        return this.FromId(9);
    }
    /**
		Returns ESignature Notification Email ContactMethodType
	**/
    get ESignatureNotificationEmail(): IContactMethodType {
        return this.FromId(10);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('1', { id: 1, value: 'PersonalCell', displayValue: 'Personal Cell', description: 'Personal Cell', sortOrder: 1, active: true });
        this._dictionary.add('2', { id: 2, value: 'BusinessCell', displayValue: 'Business Cell', description: 'Business Cell', sortOrder: 2, active: true });
        this._dictionary.add('3', { id: 3, value: 'HomeLandline', displayValue: 'Home Landline', description: 'Home Landline', sortOrder: 3, active: true });
        this._dictionary.add('4', { id: 4, value: 'BusinessLandline', displayValue: 'Business Landline', description: 'Business Landline', sortOrder: 4, active: true });
        this._dictionary.add('5', { id: 5, value: 'PersonalEmail', displayValue: 'Personal Email', description: 'Personal Email', sortOrder: 5, active: true });
        this._dictionary.add('6', { id: 6, value: 'BusinessEmail', displayValue: 'Business Email', description: 'Business Email', sortOrder: 6, active: true });
        this._dictionary.add('7', { id: 7, value: 'AlternativeEmail', displayValue: 'Alternative Email', description: 'Alternative Email', sortOrder: 7, active: true });
        this._dictionary.add('8', { id: 8, value: 'PersonalFax', displayValue: 'Personal Fax', description: 'Personal Fax', sortOrder: 8, active: true });
        this._dictionary.add('9', { id: 9, value: 'BusinessFax', displayValue: 'Business Fax', description: 'Business Fax', sortOrder: 9, active: true });
        this._dictionary.add('10', { id: 10, value: 'ESignatureNotificationEmail', displayValue: 'ESignature Notification Email', description: 'ESignature Notification Email', sortOrder: 10, active: true });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): IContactMethodType {
        return this._dictionary[id];
    }

    public FromValue(value: string): IContactMethodType {
        var match = this._dictionary.getValues().filter(d => d.value == value);

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): IContactMethodType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): IContactMethodType[] {
        return this.GetAll().filter(d => d.active);
    }

    public Sort(primaryField, secondaryField, reverse): IContactMethodType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = (path, reverse, primer, then) => {
        var get = (obj, path) => {
                if (path) {
                    path = path.split('.');

                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }

                    return obj[path[len]];
                }
                return obj;
            },
            prime = (obj) => primer ? primer(get(obj, path)) : get(obj, path);

        return (a, b) => {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
